import { render, staticRenderFns } from "./MyModal.vue?vue&type=template&id=70907957&"
import script from "./MyModal.vue?vue&type=script&lang=js&"
export * from "./MyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports